module.exports = __webpack_public_path__ + "static/media/internetOfEfficiencyLogo.74230865.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/logos/internetOfEfficiencyLogo.svg
// module id = 375
// module chunks = 0